/**
 * @return {{feature: string}}
 */
export const popinAccount = () => ({
  feature: 'interet_compte',
});
